"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Tray component.
 *
 * This is the actual tray that the dropdown menu opens up. It is where the
 * content of the dropdown is rendered.
 *
 * @class Tray
 * @public
 */
const Tray = /*#__PURE__*/(0, _react.forwardRef)(function Tray(_ref, ref) {
  let {
    className,
    children,
    open,
    renderClosed
  } = _ref;
  const renderChildren = open || renderClosed;
  const [isBrowser, setIsBrowser] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setIsBrowser(true);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: (0, _classnames.default)(className, 'tray-dropdown', isBrowser && 'loaded')
  }, renderChildren && /*#__PURE__*/_react.default.createElement("div", {
    className: "tray-content"
  }, children));
});
var _default = Tray;
/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
exports.default = _default;
Tray.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  open: _propTypes.default.bool,
  renderClosed: _propTypes.default.bool
};